import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/src/view/styles/variables';
import { Button } from '../atoms';
export const DiagnosisStepFooter = ({ isDisabled, onNext, buttonText }) => {
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement(Button, { className: css(styles.button, isDisabled && styles.buttonDisabled), onClick: onNext, disabled: isDisabled, "data-test": "diagnosisNextButton" }, buttonText)));
};
const styles = StyleSheet.create({
    container: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '16px 24px 24px',
        display: 'flex',
        justifyContent: 'center',
        [MediaBreakPointUp.MD]: {
            padding: '24px 36px 32px',
        },
    },
    button: {
        width: '100%',
        maxWidth: 327,
        height: 48,
        fontSize: 16,
        letterSpacing: 1,
        borderRadius: 999,
        border: 'none',
        color: Colors.White,
        background: Colors.GradationPrimary,
        cursor: 'pointer',
    },
    buttonDisabled: {
        opacity: 0.5,
        cursor: 'default',
    },
});
